import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersService, environment } from '@perval/shared';
import { firstValueFrom } from 'rxjs';
import { blobToBase64 } from '../../shared/utils/image.utils';

@Injectable({
  providedIn: 'root',
})
export class PhotoService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-reports/reports`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  private async handlePhotoRequest(
    url: string,
    errorMessage: string,
    customHeaders?: any,
  ): Promise<string> {
    try {
      let headers =
        await this.httpHeadersServiceService.getHeadersWithPervalContext();

      if (customHeaders) {
        headers = headers.set('Accept', customHeaders);
      }

      const response = await firstValueFrom(
        this.http.get(url, {
          headers: headers,
          observe: 'response',
          responseType: 'blob',
        }),
      );

      return await blobToBase64(response.body as Blob);
    } catch (error: any) {
      if (error.status === 404) {
        console.error(errorMessage, error);
        return '';
      }
      throw error;
    }
  }

  async getExpertPhoto(reportId: string): Promise<string> {
    return this.handlePhotoRequest(
      `${this.mainUrl}/${reportId}/section/expert/photo`,
      "Erreur lors de la récupération de la photo de l'expert:",
    );
  }

  async getOrganismePhoto(reportId: string): Promise<string> {
    return this.handlePhotoRequest(
      `${this.mainUrl}/${reportId}/section/organization/photo`,
      "Erreur lors de la récupération de la photo de l'organisme:",
    );
  }

  async getOrganismeLogo(reportId: string): Promise<string> {
    return this.handlePhotoRequest(
      `${this.mainUrl}/${reportId}/section/organization/logo`,
      "Erreur lors de la récupération du logo de l'organisme:",
    );
  }

  async getPhotography(reportId: string, index: number): Promise<string> {
    return this.handlePhotoRequest(
      `${this.mainUrl}/${reportId}/section/photographs/photo/${index}`,
      'Erreur lors de la récupération de la photographie:',
      'image/*',
    );
  }

  async getMap(reportId: string): Promise<string> {
    return this.handlePhotoRequest(
      `${this.mainUrl}/${reportId}/map/property`,
      'Erreur lors de la récupération de la carte:',
    );
  }

  async getPlotCartography(reportId: string): Promise<string> {
    return this.handlePhotoRequest(
      `${this.mainUrl}/${reportId}/section/cadastre/map`,
      'Erreur lors de la récupération de la cartographie du terrain:',
    );
  }
}
